import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import setupStore from './setupStore'
import { init as initAuth } from './utils/auth0'
import './index.css';
import App from './App';
import Router from './Router'
import * as serviceWorker from './serviceWorker';

const store = setupStore()

initAuth(store.dispatch)

ReactDOM.render((
  <Provider store={store}>
    <App><Router /></App>
  </Provider>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
